module.exports = __webpack_public_path__ + "img/logo.88832e9d.png";